import UpdateChack from "../components/configuration/chack/UpdateChack"
const UpdateChackPage = () => {
    return (
        <UpdateChack />
    )
}
export default UpdateChackPage;
